import { useCallback, useContext, useEffect, useRef, useState } from "react";

import { get } from "utils/DeApi";
import { OrganizationContext } from "contexts/OrganizationProvider";

const useFetchMembers = ({
  page,
  query,
  perPage,
  tableSortState = {
    sortColumn: "updated_at",
  },
  fetchByDefault = true,
}) => {
  const [meta, setMeta] = useState();
  const [members, setMembers] = useState([]);
  const [isLoading, setIsLoading] = useState();
  const [error, setError] = useState();
  const organization = useContext(OrganizationContext);
  const subscribedPromises = useRef([]);

  const fetchMembers = useCallback(() => {
    setError(null);
    setIsLoading(true);

    const membersPromise = get(`organizations/${organization?.id}/members`, {
      params: {
        page: page ? page : 1,
        perPage: perPage || 10,
        sort: !!tableSortState?.sortAsc
          ? tableSortState?.sortColumn
          : `-${tableSortState?.sortColumn}`,
        "filter[search]": query ? query : "",
      },
    });
    membersPromise.promise
      .then(({ data, meta }) => {
        setMeta(meta);
        setMembers(data);
      })
      .catch((error) => {
        !error.isCanceled && setError(error);
      })
      .finally(() => setIsLoading(false));

    subscribedPromises.current.push(membersPromise);
  }, [
    page,
    query,
    perPage,
    organization?.id,
    tableSortState?.sortAsc,
    tableSortState?.sortColumn,
  ]);

  useEffect(() => {
    if (fetchByDefault) fetchMembers();

    const promises = subscribedPromises.current;
    return () => {
      promises.forEach((promise) => {
        promise.cancel();
      });
    };
  }, [fetchMembers, fetchByDefault]);

  return {
    members,
    isLoading,
    error,
    meta,
    setMembers,
  };
};

export default useFetchMembers;
